export const validateAdvancePayment = ({
  amount,
  balance,
  enableAdvancePayment,
}: {
  amount: any;
  balance: any;
  enableAdvancePayment: any;
}) => {
  if (!enableAdvancePayment && balance !== null && Number(amount) > Number(balance)) {
    return `Amount cannot exceed available balance of ${Number(balance).toLocaleString()}`;
  }

  return null;
};

export const workerValidationRules = (values: any) => {
  const errors: Record<string, string> = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.name) errors.name = "Name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (values.primaryPhone && !phoneRegex.test(values.primaryPhone))
    errors.primaryPhone = "Enter valid number (with country code)";
  if (values.oldBalance && values.oldBalance <= 0) errors.oldBalance = "Old balance must be greater than 0";

  return errors;
};

export const workValidationRules = (values: any, options: any = {}) => {
  const errors: Record<string, string> = {};
  const { balance, enableAdvancePayment } = options;

  if (!values.date) errors.date = "Date is required";
  if (!values.workerId) errors.workerId = "Please select a worker";
  if (!values.projectId) errors.projectId = "Please select a project";
  if (!values.isGroupWork) {
    if (!values.wage) errors.wage = "Wage is required";
    else if (isNaN(values.wage) || values.wage <= 0) errors.wage = "Wage must be greater than 0";
  }
  if (!values.isGroupWork && values.overtimeRate && values.overtimeRate > 0) {
    if (
      values.overtimeHours !== undefined &&
      values.overtimeHours !== null &&
      values.overtimeHours !== "" &&
      Number(values.overtimeHours) !== 0
    ) {
      if (isNaN(values.overtimeHours) || values.overtimeHours < 0.5)
        errors.overtimeHours = "Overtime hours must be greater/equal to 0.5";
      else if ((values.overtimeHours * 10) % 5 !== 0) errors.overtimeHours = "Overtime hours must be a multiple of 0.5";
      else if (!/^\d+(\.\d{1,2})?$/.test(values.overtimeHours.toString()))
        errors.overtimeHours = "At most 2 decimal places are allowed";
    }
  }
  if (values.isPaid && !values.fromAccountId) errors.fromAccountId = "Please select an account";
  if (values.isPaid && !values.paidAmount) errors.paidAmount = "Paid amount is required";
  else if (values.isPaid && values.paidAmount && (isNaN(values.paidAmount) || values.paidAmount <= 0))
    errors.paidAmount = "Paid amount must be greater than 0";
  else if (values.isPaid) {
    const amountError = validateAdvancePayment({
      amount: values.paidAmount,
      balance,
      enableAdvancePayment,
    });

    if (amountError) errors.paidAmount = amountError;
  }

  return errors;
};
